<template>
	<div class="footer-bar">
		<div class="partnerbox">
			<div class="partner">
				<div class="partnerlogo uno">
					<img :src="require('@/assets/csen_big.gif')" width="110"/>
				</div>
				<div class="partnerlogo due">
					<img :src="require('@/assets/unimi.png')" width="110"/>
				</div>
				<div class="partnerlogo tre">
					<img :src="require('@/assets/fms.png')" width="150"/>
				</div>
				<div class="partnerlogo quattro">
					<img :src="require('@/assets/exos.png')" width="170"/>
				</div>
				<div class="partnerlogo cinque">
					<img :src="require('@/assets/lacertosus_big.png')" width="200"/>
				</div>
			</div>
		</div>

		<div style="clear:both;"></div>

		<div class="upper">
			<div class="container-desktop">
				<div class="float-left footer-logo">
					<div class="logo">
						<img :src="require('@/assets/logo_white.png')" width="48"/>
					</div>
				</div>	
			</div>
		</div>
		<div class="lower">
			<div class="container-desktop">
				<div class="float-right">
					<div class="other-links f-xs">
						<a href="https://www.iubenda.com/privacy-policy/80398492/full-legal" target="_blank">Privacy Policy</a>
						<span>&bullet;</span>
						<a href="/terms.html" target="_blank">Termini e Condizioni</a>
						<span>&bullet;</span>
						<a href="/sitemap.xml" target="_blank">Sitemap</a>
						<span>&bullet;</span>
						<a href="https://www.iubenda.com/privacy-policy/80398492/cookie-policy" target="_blank">Cookie Policy</a>
					</div>
					<div class="social-list">
						<a class="fab fa-facebook fa-fw" href="https://www.facebook.com/eximusperformance/" target="_blank"></a>
						<a class="fab fa-instagram fa-fw" href="https://www.instagram.com/eximus_performance/" target="_blank"></a>
					</div>
				</div>
				
				<div class="float-left">
					<div class="c-lightish f-xs">&copy;2025 EXIMUS PERFORMANCE - Via Milano, 8 Seregno (MB)<br>Email: eximus.performance@gmail.com - Tel. 3387118020</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'footer-bar'
}
</script>

<style lang="stylus" scoped>
.social-list
	float right
	margin-top 0.2em
	margin-left 0.2em
	font-size 1.4em
	@media (max-width: unit(media-phone-max, px))
		float none
		width 78px
		margin 0.5em auto

	>a
		padding 0.3em

		color light

		text-decoration none

		transition 0.15s ease

		&:hover
			border-radius 50%

			background-color dark

			&.fa-facebook
				color #30C0F0
			&.fa-instagram
				color #D080D0

.partnerlogo
	margin-left 2.5em
	float left 

	@media (max-width: unit(950, px))
		float none
		margin-left 0px

.uno 
	margin-top 26px

	@media (max-width: unit(950, px))
		margin-top 0px
		margin-left 45px

.due
	margin-top 26px
	
	@media (max-width: unit(950, px))
		margin-top 3em
		margin-left 45px
		
.tre 
	margin-top 40px

	@media (max-width: unit(950, px))
		margin-top 3em
		margin-left 25px

.quattro
	margin-top 46px

	@media (max-width: unit(950, px))
		margin-top 3em
		margin-left 15px

.cinque
	margin-top 56px

	@media (max-width: unit(950, px))
		margin-top 3em
		margin-left 0px

.partner
	margin 0 auto
	width 940px
	height 100%

	@media (max-width: unit(950, px))
		width 200px

.partnerbox
	background-color #232b34
	height 160px

	@media (max-width: unit(950, px))
		height 100%
		padding-bottom 2em
		padding-top 2em
		margin-bottom 2em

	
.float-left
	float left
	@media (max-width: unit(media-phone-max, px))
		float none
		width 298px
		margin 0 auto


.float-right
	float right
	@media (max-width: unit(media-phone-max, px))
		float none
		width 310px
		margin 0 auto

.footer-logo 
	@media (max-width: unit(media-phone-max, px))
		width 50px

.upper
	padding 1em
	
	background-color dark
		
	&:after
		content ''
		display block
		
		clear both

.lower
	padding 1em
	
	background-color darker
	
	.other-links
		color lightish
		
		a
		span
			margin 0 0.3em
			
			color lightish

			font-size 1em

			text-decoration none
			
			cursor pointer
			
			&:hover
				color light
				
				text-decoration underline
	
	&:after
		content ''
		display block

		clear both	
</style>
